import { useCallback } from 'react';
import { useApiCall } from './apiHelpers';

const useDeleteOfferInput = () => {
  const { authFetch, isReady, run } = useApiCall();

  const deleteOfferInput = useCallback(
    async (id: number): Promise<boolean> => {
      if (!isReady) return false;
      const outcome = await run(
        () => authFetch(`/offer_inputs/${id}`, { method: 'DELETE', headers: { Accept: 'application/ld+json' } }),
        "Erreur lors de la suppression de l'offre",
      );
      return outcome.ok;
    },
    [authFetch, isReady, run],
  );

  return { deleteOfferInput };
};

export default useDeleteOfferInput;
